import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMAgent } from "../graphql/mutations";
import { CreateLLMAgentInput, CreateLLMAgentMutation, LLMEmailCaptureMode, LLMVisibility } from "../API";

export async function createLLMAgentAfterEdit(
  values: CreateLLMAgentInput
): Promise<GraphQLResult<CreateLLMAgentMutation>> {
  return API.graphql(
    graphqlOperation(createLLMAgent, {
      input: {
        name: values.name,
        status: values.status,
        projectId: values.projectId,
        description: values.description || "",
        systemInstructions: values.systemInstructions || "",
        systemInstructionsAction: values.systemInstructionsAction || "",
        groupId: values.groupId !== undefined ? values.groupId : "",

        displayTheme: values.displayTheme || "",
        cssUrl: values.cssUrl || "",
        displayTitle: values.displayTitle || "",
        displayStartMessageOrPrompt: values.displayStartMessageOrPrompt || "",
        displayInitialMessageOrPrompt:
          values.displayInitialMessageOrPrompt || "",
        displayPromptTemplate: values.displayPromptTemplate || "",
        displayFollowOnPrompts: values.displayFollowOnPrompts || "",
        displayActions: values.displayActions || "",
        displayWidth: values.displayWidth || "",
        displayHeight: values.displayHeight || "",

        displayPlaceholder : values.displayPlaceholder || "",
        displayHideInitialPrompt: values?.displayHideInitialPrompt ?? true,
        displayShowSaveButton: values?.displayShowSaveButton ?? true,
        displayShowEmailButton: values?.displayShowEmailButton ?? true,
        displayShowCallToAction: values?.displayShowCallToAction ?? false,
        displayCallToActionButtonText: values.displayCallToActionButtonText || "Submit",
        displayCallToActionEmailAddress: values.displayCallToActionEmailAddress || "",
        displayCallToActionEmailSubject: values?.displayCallToActionEmailSubject || "Agent CTA Submitted",

        displayScrollToEnd: values?.displayScrollToEnd ?? false,
        data: values.data || "",

        ragQueryLimit: values.ragQueryLimit || 10,
        ragRankLimit: values.ragRankLimit || 5,
        ragIncludeCitations: values.ragIncludeCitations ?? false,
    
        visibility: values?.visibility || LLMVisibility.PUBLIC,

        createConversationOnFirstChat: values.createConversationOnFirstChat ?? true,
        customerEmailCaptureMode: values.customerEmailCaptureMode || LLMEmailCaptureMode.HIDE,
        customerEmailCapturePlaceholder: values.customerEmailCapturePlaceholder || "Please enter your email...",
      },
    })
  ) as Promise<GraphQLResult<CreateLLMAgentMutation>>;
}
